module.exports = __webpack_public_path__ + "img/B9.ab5405dc.png";